module.exports = __webpack_public_path__ + "static/media/seguranca.d32234b7.jpg";